export interface UploadHistoryScope {
  organisationId?: string;
  locationId?: string;
  connectionId?: string;
  connectionIds?: string[];
  sourceId?: string;
}
export interface UploadPeriodRow {
  periodId: string; sourceId: string; organisationId: string; organisationName: string;
  locationId: string; locationName: string; connectionId: string; connectionCode: string;
  dataType: string; unit: string; month: string; volume: number | string; pointCount: number;
  revision: number; deleted: boolean; updatedAt?: string; status: string; fileName?: string;
  canManage: boolean; legacy: boolean; deletionBlocked?: boolean;
}
export interface UploadValueChange {
  timeRange: {start: string; end: string}; previousValue?: number | string; value?: number | string;
}
export interface UploadRevision {
  revision: number; timestamp: string; actor: string; actorName?: string; action: string; fileName?: string; archiveId?: string;
  previousVolume: number | string; volume: number | string; added: number; changed: number;
  unchanged: number; removed: number; changes: UploadValueChange[]; changeCount: number;
}
export interface UploadPeriodDetails {
  period: UploadPeriodRow; history: UploadRevision[]; historyCount: number;
}
export function periodActionPayload(row: UploadPeriodRow, action: 'DELETE' | 'RESTORE') {
  if (!row.canManage || row.deletionBlocked || (action === 'DELETE') === row.deleted) {
    throw new Error('The selected upload action is unavailable');
  }
  return {sourceId: row.sourceId, dataType: row.dataType, month: row.month,
    expectedRevision: row.revision, action};
}
export function uploadStatus(status: string): string {
  return ({IMPORTED: 'Processed', CORRECTED: 'Corrected', UNCHANGED: 'Unchanged',
    DELETE: 'Deleted', RESTORE: 'Restored', TRANSFERRED: 'Transferred', LEGACY: 'Existing data'})[status] || status;
}

/** A single selected location opens all its upload sources, also after an ordinary upload. */
export function locationUploadScope(entities: {location?: {locationId?: string}; connection?: {connectionId?: string}}[]): UploadHistoryScope {
  entities = entities.filter(entity => !!entity.connection?.connectionId);
  const locationIds = new Set(entities.map(entity => entity.location?.locationId));
  return entities.length && locationIds.size === 1 && entities[0].location?.locationId
    ? {locationId: entities[0].location.locationId}
    : {connectionIds: entities.map(entity => entity.connection.connectionId)};
}
